import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {Button} from 'components';
import styles from './Accordion.module.scss';
import {IconsSocial} from './components';
import {IconsProducts} from '..';

export const Accordion = ({
  groupId,
  preview,
  products,
  allProducts,
  meeting,
  user,
  social,
  inModal,
}) => {
  const accordionRef = useRef();

  useEffect(() => {
    const groupClassName = accordionRef.current.parentElement.classList;
    groupClassName.add('open');
    return () => groupClassName.remove('open');
  }, []);

  return (
    <div
      ref={accordionRef}
      className={cn(styles.wrap, {[styles.inModal]: inModal})}
    >
      <div className={styles.left}>
        <div className={styles.preview}>{preview}</div>
        {inModal && (
          <div className={styles.productsWrap}>
            <IconsProducts icons={products} />
          </div>
        )}

        <div className={styles.productsWrapMobile}>
          <IconsProducts icons={products} />
        </div>
        <div className={styles.allProducts}>{allProducts}</div>
      </div>
      <div className={styles.connect}>
        <IconsSocial groupId={groupId} social={social} />
        {user.name && (
          <div className={styles.groupLeader}>
            <strong>Group leader: </strong>
            {user.link ? (
              <Button
                target="_blank"
                rel="noopener noreferrer"
                href={
                  user.link.match(/.+?@.+/) ? 'mailto:' + user.link : user.link
                }
                type="link"
              >
                {user.name}
              </Button>
            ) : (
              user.name
            )}
          </div>
        )}
        {meeting && <div><strong>Meetup cadence:</strong> {meeting}</div>}
      </div>
    </div>
  );
};

Accordion.propTypes = {
  groupId: PropTypes.string.isRequired,
  preview: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.string),
  allProducts: PropTypes.string,
  meeting: PropTypes.string,
  user: PropTypes.shape({
    link: PropTypes.string,
    name: PropTypes.string,
    publish: PropTypes.bool,
  }),
  social: PropTypes.arrayOf(PropTypes.string),
  inModal: PropTypes.bool,
};

Accordion.defaultProps = {
  preview: null,
  products: [],
  allProducts: null,
  meeting: null,
  user: {
    link: null,
    name: null,
    publish: false,
  },
  social: [],
  inModal: false,
};
